/** @param {string} str */
export const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

/** @param {string} str */
export const capitalizeAll = (str) => {
  return str
    .split(' ')
    .map((word) => capitalize(word))
    .join(' ')
}

/** @param {string} str */
export const pluralize = (str) => {
  if (str.endsWith('y')) return str.slice(0, -1) + 'ies'
  if (['s', 'sh', 'ch', 'x', 'z'].some((suffix) => str.endsWith(suffix))) return str + 'es'
  return str + 's'
}
